import { render, staticRenderFns } from "./ClientesAgenda.vue?vue&type=template&id=d565ef46&scoped=true&lang=pug&"
import script from "./ClientesAgenda.vue?vue&type=script&lang=js&"
export * from "./ClientesAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d565ef46",
  null
  
)

export default component.exports